import { API_URL } from 'config';
import { makeAPICall } from './api';

export declare namespace API {
    export interface Switch {
        id: number;
        switch_id: string;
        name: string;
        description: string;
        type: string;
        read_only: boolean;
        satellite_operator_allowed: boolean;
        value: string;
        pending_value: string;
        value_to_text_mapping: Record<string, string>;
        config: Record<string, string | number | boolean>;
        last_updated: string;
        created: string;
        ground_station: number;
    }
}

export interface Switch {
    id: number;
    switchId: string;
    name: string;
    description: string;
    type: string;
    readOnly: boolean;
    satelliteOperatorAllowed: boolean;
    value: string;
    pendingValue: string;
    valueToTextMapping: Record<string, string>;
    config: Record<string, string | number | boolean>;
    last_updated: string;
    created: Date;
    groundStation: number;
}

const SWITCHES_ROUTE = '/switches';

export const mapAPIToSatellite = ({
    switch_id,
    read_only,
    satellite_operator_allowed,
    pending_value,
    value_to_text_mapping,
    ground_station,
    created,
    ...rest
}: API.Switch): Switch => ({
    ...rest,
    switchId: switch_id,
    readOnly: read_only,
    satelliteOperatorAllowed: satellite_operator_allowed,
    pendingValue: pending_value,
    valueToTextMapping: value_to_text_mapping,
    groundStation: ground_station,
    created: new Date(created),
});

export const listSwitches = makeAPICall<
    Switch[],
    { groundStationId: number },
    { results: API.Switch[] }
>(
    ({ groundStationId }) => ({
        url: `${API_URL}${SWITCHES_ROUTE}/?ground_station=${groundStationId}`,
    }),
    (data) => data.results.map(mapAPIToSatellite),
);

export const getSwitchById = makeAPICall<Switch, { id: number }, API.Switch>(
    ({ id }) => ({
        url: `${API_URL}${SWITCHES_ROUTE}/${id}/`,
    }),
    (satellite) => mapAPIToSatellite(satellite),
);
